import { refreshAccessToken } from "./apiClient";
import { API_URL } from "./constant"

// list comparable
// export async function listComparables(page=1,size=10,orderId) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/comparables/?page=${page}&page_size=${size}&order_id=${orderId}`,{
//             method: 'GET',
//             headers:{
//                 'Authorization': `Bearer ${parsedToken}`,
//             }
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error('Failed to fetch comparable list');
//                 err.data = responseData;
//                 err.status = response.status;
//                 throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("error while getting list of orders", error?.data || error.message)
//         throw error;
//     }
// }
export async function listComparables(page = 1, size = 10, orderId) {
  let accessToken = JSON.parse(localStorage.getItem("accessToken"));

  try {
    const response = await fetch(
      `${API_URL}/comparables/?page=${page}&page_size=${size}&order_id=${orderId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 401) {
      const newAccessToken = await refreshAccessToken();

      const retryResponse = await fetch(
        `${API_URL}/comparables/?page=${page}&page_size=${size}&order_id=${orderId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${newAccessToken}`,
          },
        }
      );

      if (!retryResponse.ok) {
        throw new Error("Retry failed");
      }

      return await retryResponse.json();
    }

    if (!response.ok) {
      throw new Error("Failed to fetch comparables");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching comparables", error.message);
    throw error;
  }
}

// add comparable
// export async function addComparables(data) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))
//         console.log("data in api",data)
//         const response = await fetch(`${API_URL}/comparables/?order_id=${data.orderId}`,{
//             method: 'POST',
//             headers:{
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(data)
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Failed to create");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("error while creating the comp or subj", error?.data || error.message)
//         throw error;
//     }
// }
// 👇 Internal helper (not exported)
async function attemptAddComparables(data, token) {
  const response = await fetch(`${API_URL}/comparables/?order_id=${data.orderId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Failed to create comparable");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// 👇 This name stays the same for TanStack usage
export async function addComparables(data) {
  let accessToken = JSON.parse(localStorage.getItem("accessToken"));

  try {
    return await attemptAddComparables(data, accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptAddComparables(data, newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("Error while creating the comparable or subject", error?.data || error.message);
    throw error;
  }
}

// update
// export async function updateCompOrSub(data) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))
//         console.log("data on api", data)
//         const response = await fetch(`${API_URL}/update_subject_comparables/`,{
//             method:'PATCH',
//             headers:{
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(data)
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Failed to update");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;
//     }catch(error){
//         console.log("error while updating subj or comp", error?.data || error.message)
//         throw error;
//     }
    
// }
// 👇 Internal helper to handle the request
async function attemptUpdateCompOrSub(data, token) {
  const response = await fetch(`${API_URL}/update_subject_comparables/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Failed to update");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// 👇 Main function (no change in name)
export async function updateCompOrSub(data) {
  let accessToken = JSON.parse(localStorage.getItem("accessToken"));

  try {
    return await attemptUpdateCompOrSub(data, accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptUpdateCompOrSub(data, newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("Error while updating subj or comp", error?.data || error.message);
    throw error;
  }
}

// get the identification and markte area details if exist
// export async function getIdentiMarketData(orderId,id) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/identification_n_market/?order_id=${orderId}&id=${id}`,{
//             method:'GET',
//             headers:{
//                 'Authorization': `Bearer ${parsedToken}`,
//             }
//         })
        
//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error('Failed to fetch identification and market data');
//                 err.data = responseData;
//                 err.status = response.status;
//                 throw err;
//         }

//         return responseData;
//     }catch(error){
//         console.log("error while getting identification & market data", error?.data || error.message)
//         throw error;
//     }
// }

// Internal helper
async function attemptGetIdentiMarketData(orderId, id, token) {
  const response = await fetch(`${API_URL}/identification_n_market/?order_id=${orderId}&id=${id}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Failed to fetch identification and market data");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Main function (do not rename!)
export async function getIdentiMarketData(orderId, id) {
  let accessToken = JSON.parse(localStorage.getItem("accessToken"));

  try {
    return await attemptGetIdentiMarketData(orderId, id, accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptGetIdentiMarketData(orderId, id, newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("Error while getting identification & market data", error?.data || error.message);
    throw error;
  }
}

// add identification and market
// export async function addIdentificationMarket(data) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'));

//         const response = await fetch(`${API_URL}/identification_n_market/?order_id=${data.orderId}&id=${data.id}`,{
//             method:'POST',
//             headers:{
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(data)
//         })
//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Failed to update");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;
//     }catch(error){
//         console.log("error while getting identification & market data", error?.data || error.message)
//         throw error;
//     }
// }

// Internal helper
async function attemptAddIdentificationMarket(data, token) {
  const response = await fetch(`${API_URL}/identification_n_market/?order_id=${data.orderId}&id=${data.id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Failed to update");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Main function (do not rename!)
export async function addIdentificationMarket(data) {
  let accessToken = JSON.parse(localStorage.getItem("accessToken"));

  try {
    return await attemptAddIdentificationMarket(data, accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptAddIdentificationMarket(data, newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("Error while adding identification & market data", error?.data || error.message);
    throw error;
  }
}

// update identification and market
// export async function updateIdenMarket(data) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'));

//         const response = await fetch(`${API_URL}/identification_n_market/?order_id=${data.orderId}&id=${data.id}`,{
//             method:"PATCH",
//             headers:{
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(data)
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Failed to update");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;
//     }catch(error){
//         console.log("error while getting identification & market data", error?.data || error.message)
//         throw error;
//     }
// }

// Internal helper
async function attemptUpdateIdenMarket(data, token) {
  const response = await fetch(`${API_URL}/identification_n_market/?order_id=${data.orderId}&id=${data.id}`, {
    method: "PATCH",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(data)
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Failed to update");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Main function (do not rename!)
export async function updateIdenMarket(data) {
  let accessToken = JSON.parse(localStorage.getItem('accessToken'));

  try {
    return await attemptUpdateIdenMarket(data, accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptUpdateIdenMarket(data, newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("Error while updating identification & market data", error?.data || error.message);
    throw error;
  }
}

// api for adding the tpar and tmar values
// Internal helper
async function attemptTmarAndTmprValues(data, token) {
  const response = await fetch(`${API_URL}/addtmpr_tmar/`, {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(data)
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Failed to update tmar and tmpr values");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Main function (do not rename!)
export async function addTmarAndTmprValues(data) {
  let accessToken = JSON.parse(localStorage.getItem('accessToken'));

  try {
    return await attemptTmarAndTmprValues(data, accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptTmarAndTmprValues(data, newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("Error while updating tmar and tmpr values", error?.data || error.message);
    throw error;
  }
}

// api for mmarking the selected comparables in the db
// export async function updatedIsSelected(payload) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/selected_comparables/`,{
//             method:'PATCH',
//             headers:{
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(payload)
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Failed to update");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("error while upadating the comparables as selected one", error?.data || error.message)
//         throw error;
//     }
// }

// Internal helper
async function attemptUpdatedIsSelected(payload, token) {
  const response = await fetch(`${API_URL}/selected_comparables/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Failed to update");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Main function (do not rename!)
export async function updatedIsSelected(payload) {
  let accessToken = JSON.parse(localStorage.getItem('accessToken'));

  try {
    return await attemptUpdatedIsSelected(payload, accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptUpdatedIsSelected(payload, newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("Error while updating comparables as selected", error?.data || error.message);
    throw error;
  }
}

// delete comp api _only updating the is_deleted
// export async function deleteComp(payload) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/delete_comparable/`,{
//             method:"PATCH",
//             headers:{
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(payload)
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Failed to delete");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("error while deleting comp", error?.data || error.message)
//         throw error;
//     }
// }

// Internal helper
async function attemptDeleteComp(payload, token) {
  const response = await fetch(`${API_URL}/delete_comparable/`, {
    method: "PATCH",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Failed to delete");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Main function
export async function deleteComp(payload) {
  let accessToken = JSON.parse(localStorage.getItem('accessToken'));

  try {
    return await attemptDeleteComp(payload, accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptDeleteComp(payload, newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("Error while deleting comp", error?.data || error.message);
    throw error;
  }
}

// change seq
// Internal helper
async function attemptUpdateSeq(payload, token) {
  const response = await fetch(`${API_URL}/bulk_update_comp_seq/`, {
    method: "PATCH",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  });

  const responseData = await response.json();

  if (!response.ok) {
    const err = new Error("Failed to update sequences");
    err.data = responseData;
    err.status = response.status;
    throw err;
  }

  return responseData;
}

// Main function
export async function updateCompSeq(payload) {
  let accessToken = JSON.parse(localStorage.getItem('accessToken'));

  try {
    return await attemptUpdateSeq(payload, accessToken);
  } catch (error) {
    if (error.status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        return await attemptUpdateSeq(payload, newAccessToken);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError.message);
        throw refreshError;
      }
    }

    console.log("Error while updating sequences", error?.data || error.message);
    throw error;
  }
}
